import domReady from "@wordpress/dom-ready";

domReady(() => {
	const dropdowns = document.querySelectorAll(
		".wp-block-qasas-companion-dropdown-products-menu",
	);

	if (!dropdowns.length) return;

	dropdowns.forEach(initializeDropdown);
});

function initializeDropdown(dropdown) {
	const buttonTrigger = dropdown.getAttribute("data-button-trigger") === "true";
	const button = dropdown.querySelector("button");
	const dropdownContent = dropdown.querySelector(
		".wp-block-qasas-companion-dropdown-products-menu-content",
	);

	const eventType = buttonTrigger ? "mouseover" : "click";
	button.addEventListener(eventType, toggleDropdown);
	
	// Add mouseleave event listener to the dropdown
	if (buttonTrigger) {
		dropdown.addEventListener("mouseleave", hideDropdown);
	}

	function toggleDropdown() {
		if (eventType === "click") {
			dropdownContent.classList.toggle("show");
		} else {
			dropdownContent.classList.add("show");
		}
	}

	function hideDropdown() {
		dropdownContent.classList.remove("show");
	}
}
